var $ = require('../internals/export');
var hasOwn = require('../internals/has');

// `Object.hasOwn` method
// https://github.com/tc39/proposal-accessible-object-hasownproperty
$({ target: 'Object', stat: true }, {
  hasOwn: hasOwn
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/modules/esnext.object.has-own.js
// module id = 974
// module chunks = 1 2 3 4